<script lang="ts">
	import type { InputSelectProps } from '@wiseed/wikit';
	import type { Country } from 'world-countries';
	import { onMount } from 'svelte';
	import InputSelect from '@app/components/inputs/AppInputSelect.svelte';
	import { InputText } from '@wiseed/wikit';
	import { capitalize } from '@wiseed/wikit';
	export let props: InputSelectProps;
	export let isFetching = true;
	let countriesProps;

	onMount(async () => {
		const getCountriesList = async () => {
			const res = await fetch('/countries/');
			return await res.json();
		};

		isFetching = true;
		try {
			const countries = await getCountriesList();
			countriesProps = countries
				.sort((e1: Country) => (e1.translations.fra.common.toLowerCase() === 'france' ? -1 : 1))
				.map((c: Country) => {
					let textLabel = c.translations.fra.common.toLowerCase();
					if (textLabel === 'france') {
						textLabel = 'France et DROM COM';
					}
					return { label: `${c.flag} ${capitalize(textLabel)}`, value: c.cca3 };
				});
		} catch (e) {
			console.error('Server Error - Cannot get countries');
		} finally {
			isFetching = false;
		}
	});
	$: if (countriesProps?.length && !!props)
		props = Object.assign(props, {
			withSearchBar: true,
			required: true,
			options: countriesProps
		});
</script>

{#if !isFetching}
	{#if props?.options}
		<InputSelect bind:props />
	{:else if props?.ref}
		<InputText bind:props />
	{/if}
{/if}
